// extracted by mini-css-extract-plugin
export default {"skeleton":"style_skeleton__JDo8C","shimmer":"style_shimmer__lo0+B"};